import { Module } from '@nestjs/common';
import { MailModule } from 'src/mail/mail.module';
import { NotificacionesModule } from 'src/notificaciones/notificaciones.module';
import { PrismaModule } from 'src/prisma/prisma.module';
import { CodigosVerificacionController } from './codigos-verificacion.controller';
import { CodigosVerificacionService } from './codigos-verificacion.service';
@Module({
  imports: [PrismaModule, MailModule, NotificacionesModule],
  controllers: [CodigosVerificacionController],
  providers: [CodigosVerificacionService],
  exports: [CodigosVerificacionService],
})
export class CodigosVerificacionModule {}
